import { render, staticRenderFns } from "./OrderCustomerData.vue?vue&type=template&id=2645c140&"
import script from "./OrderCustomerData.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports